import FilterIcon from 'modules/cp_membersAndPermissions/assets/icons/FilterIcon';

import style from './style.module.css';

//Todo: remove any
const HeaderFilterIcon = () => {
  return (
    <div className={style.HeaderFilterIcon}>
      <FilterIcon />
    </div>
  );
};

export default HeaderFilterIcon;
